import type { KataId } from '../catalog/types'

/** Applied / suggested mistake severity for IJF deductions. */
export type MistakeSeverity = 'small' | 'medium' | 'big'

/** Labels from criteria docs; `small_medium` means the judge chooses small or medium. */
export type SuggestedMistake =
  | MistakeSeverity
  | 'small_medium'
  | 'forgotten'

export type ScoredElementKind = 'ceremony' | 'technique'

export interface ScoringCriterion {
  id: string
  /** English observation text (IJF criteria). */
  text: string
  suggested: SuggestedMistake
  /** Optional note shown under the suggestion (e.g. conditional Medium). */
  hint?: string
}

export interface ScoredElement {
  id: string
  kind: ScoredElementKind
  /** Display name (romaji / English). */
  name: string
  nameJa?: string
  /** Link to catalog technique when kind is technique. */
  techniqueId?: string
  groupId?: string
  criteria: ScoringCriterion[]
}

export interface KataScoringDefinition {
  kataId: KataId
  /** Must match IJF max / 10. */
  elements: ScoredElement[]
  maxPerJudge: number
  maxPanelOfThree: number
}

export const RULE_TABLE_VERSION = 'ijf-deductions-v1' as const

export const DEDUCTION_POINTS: Record<MistakeSeverity, number> = {
  small: 1,
  medium: 3,
  big: 5,
}

export const ELEMENT_BASE_POINTS = 10
